import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ProgressService} from '../../../services/progress.service';
import {Subscription} from 'rxjs';
import {ProgressModel} from '../../../services/models/progress.model';
import {EventsService} from '../../../services/events.service';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {NavService} from '../../../services/nav.service';
import {IonMenu} from '@ionic/angular';
import {UserService} from '../../../services/user.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
    ],
})
export class MenuComponent implements OnInit, OnDestroy {

    @ViewChild(IonMenu, {static: true, read: IonMenu}) menu: IonMenu;

    private subscriptions: Subscription[] = [];

    environment = null;
    userType = null;
    progress: ProgressModel = null;
    progressValid = true;
    isManager = false;
    isTaskEnabled = false

    constructor(
        private nav: NavService,
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private progressService: ProgressService,
    ) {
        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.progressValid = false;
                this.menu.disabled = false;
                this.userType = this.authService.getUserType();
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => {
                this.progressValid = false;
                this.menu.disabled = true;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('tasks:updateTaskStatus', () => this.progressValid = false)
        );
        this.subscriptions.push(
            this.event.subscribe('progress:getMyNotifications', (progress) => {
                this.progress = progress;
                this.progressValid = true;
            })
        );

        this.userType = this.authService.getUserType();
    }

    ngOnInit() {
        if (!this.authService.isLoggedin()) {
            this.menu.disabled = true;
        }
    }

    ionMenuWillOpen() {
        this.isManager = (this.authService.getUserType() === 'manager');
        // this.isTaskEnabled = (this.authService.getUserCompanyDashboard() === 'classic');
        this.isTaskEnabled = true;

        if (this.progress === null || !this.progressValid) {
            if (this.progressValid && this.progressService.progress !== null) {
                this.progress = this.progressService.progress;
            } else {
                this.progressService.getMyNotifications()
                    .then(data => {
                        this.progress = data;
                        this.progressValid = true;
                    });
            }
        }
    }

    navigate(commands: any[]) {
        this.nav.navigateBack(commands);
    }

    navigateHome() {
        this.nav.navigateHome();
    }

    getActionLogOut() {
        this.nav.logout();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
